import {useState,useEffect,useMemo} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import useWindowSize from '../../../hooks/useWindowSize'
import {useRecipes} from '../../recipes/hooks'
import {createMeal,editMeal} from '../../../state/events'
import {update as updateResourceLibrary} from '../slice'
import MacroTotals from '../../recipes/MacroTotals'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {useDebounceCallback} from '@react-hook/debounce'

import {slidingQueryComparision,capitalize, envAwarePost} from '../../../util/util'

const Recipe = ({recipe})=>{
	const dispatch = useDispatch()
	const shortNutrientMap = {
		calories:'cal',
		carbohydrate:'carb',
		protein:'pro',
		fat:'fat'
	}
	//get replace state. This holds the id and type of the item
	//getting replaced. The id will be falsey if not replacing
	const {replace,insertPosition} = useSelector(
		state => state.resourceLibrary
	)
	const replacing = Boolean(replace.id)

	const handleCreateMeal = ()=>{
		dispatch(
			createMeal({
				routine_order:Number(insertPosition),
				recipe_id:recipe.recipe_id,
				name:recipe.recipe_name,
				recipe_source:'fatsecret'
			})
		)
		dispatch(
			updateResourceLibrary({insertPosition:Number(insertPosition)+1})
		)
	}

	const [status,setStatus] = useState('idle')
	const handleReplaceMeal = ()=>{
		setStatus('pending')
		dispatch(editMeal({
			id:replace.id,
			recipe_source:'fatsecret',
			update:{
				recipe_id:recipe.recipe_id,
				name:recipe.recipe_name,
				recipe_source:'fatsecret'
			}
		})).finally(()=>{
			dispatch(updateResourceLibrary({replace:{}}))
			setStatus('idle')
		})
	}
	
	const handleClick = ()=>{
		if(replacing){
			handleReplaceMeal()
		}else {
			handleCreateMeal()
		}
	}
	return (
		<div style={{
			padding:'4px',
			display:'flex',
			marginBottom:'4px',
			borderBottom:'1px solid #ccc',
			alignItems:'center'
		}}>
			<Button onClick={handleClick} variant="outline-success" size="sm" className="mr-2">
				{(replacing&&status!=='pending')&&
					<i className="fa fa-exchange-alt"/>
				}

				{(!replacing&&status!=='pending')&&
					<i className="fa fa-plus"/>
				}

				{status==='pending'&&
					<Spinner animation="border" size="sm"/>
				}
			</Button>
			<img 
				style={{
					width:'36px',
					height:'36px',
					objectFit:'cover',
					borderRadius:'7px',
					overflow:'hidden',
					marginRight:'4px'
				}}
				src={recipe.recipe_image}
			/>
			<div>
				<strong>
					{recipe.recipe_name}
				</strong>
			</div>
			<div style={{
				display:'flex',
				marginLeft:'auto'
			}}>
				{Object.entries(recipe.recipe_nutrition).map(([macro,value])=>(
					<div style={{
						fontSize:'12px',
						textAlign:'right',
						marginLeft:'8px',
						width:'30px'
					}}>
						<div style={{
							lineHeight:'12px',
							color:'#1d7a5a'
						}}>
							{shortNutrientMap[macro]}
						</div>
						<div>
							{value.split('.')[0]}
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default function Catalog ({typeSelector}) {
	const [recipes,setRecipes] = useState([])
	console.log(recipes)
	const [searchQuery,setSearchQuery] = useState('')

	const [windowWidth,windowHeight] = useWindowSize()

	const search = async query => {
		setStatus('pending')
		const res = await envAwarePost('api/recipes/', { action: 'searchRecipeCatalog',query })
		if(res) setStatus('idle')
		if ( res.success === '1') {
			setRecipes(res.data.recipes)
		}
		else{
			window.alert(res.message)
		}
	}

	const debouncedSearch = useDebounceCallback(search,400)

	const [status,setStatus] = useState('idle')

	const [expandedRecipeId,setExpandedRecipeId] = useState(false)

	useEffect(()=>{
		setRecipes([])
		if (!searchQuery) return 
		setStatus('typing')
		debouncedSearch(searchQuery)
	},[searchQuery])


	return (
		<div 
			style={{
				width:'100%',
				height:'100%',
			}}
			className="d-flex align-items-stretch flex-column flex-md-row"
		>
			<div 
				className="p-2" 
				style={{
					background:'#e5e7f5',
					width:windowWidth>767?'180px':'100%',
					flex:'0 0 auto'
				}}
			>
				{typeSelector}
				<Form.Control 
					onChange={e=>{
						setSearchQuery(e.target.value)
					}}
					value={searchQuery}
					placeholder="search"
					size="sm"
				/>
				<a href="https://www.fatsecret.com">
					<img src="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret.png" srcset="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_2x.png 2x, https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_3x.png 3x" border="0"/>
				</a>
			</div>
			<div style={{flex:'1 1 auto',overflow:'scroll'}}>
				{status==='pending'&&
					<div style={{
						padding:'16px'
					}}>
						<Spinner animation="border"/>
					</div>
				}
				{status==='idle'&&recipes.map(recipe=><Recipe recipe={recipe}/>)}
				{(status==='idle'&&!Boolean(searchQuery))&&
					<div style={{
						padding:'16px'
					}}>
						Search for a recipe using the textbox to the left
					</div>
				}
				{status==='typing'&&
					<div style={{
						padding:'16px'
					}}>
						Waiting...
					</div>
				}
				{(status==='idle'&&Boolean(searchQuery)&&recipes.length===0)&&
					'No results'
				}
			</div>
		</div>
	)
}